import React from 'react';
import {ButtonProps} from '../../../interfaces';
import ButtonRender from './ButtonRender';

export const Button =({...props}:ButtonProps):JSX.Element=>{
	return <ButtonRender {...props}/>;
};